import { render } from "./chamados-list-syncfusion.vue?vue&type=template&id=be43e2f2"
import script from "./chamados-list-syncfusion.vue?vue&type=script&lang=js"
export * from "./chamados-list-syncfusion.vue?vue&type=script&lang=js"

import "./chamados-list-syncfusion.vue?vue&type=style&index=0&id=be43e2f2&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__